<template>
  <v-container>
    <h3 class="page-title">民眾預約修改查詢</h3>
    <v-text-field
      v-model="身分證字號"
      label="身分證字號"
      outlined
      dense
      @keyup.enter="load"
      @click:clear="person = null"
      clearable
    >
      <v-icon class="pointer" slot="append" @click="load"> mdi-magnify </v-icon>
    </v-text-field>
    <v-divider></v-divider>
    <div v-if="person">
      <basic :person="{ ...person }" @load="load"></basic>
      <reserve v-if="有預約" :person="{ ...person }" @load="load"></reserve>
      <v-card class="mt-8">
        <v-card-title>問卷內容</v-card-title>
        <v-card-text>
          <div v-if="!hasSurvey">尚無問卷資料</div>
          <v-simple-table v-else dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in surveyItems" :key="item.key">
                  <th class="text-left survey-key">{{ item.key }}</th>
                  <td class="text-left survey-value">{{ item.value }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import basic from "@/components/People/basic.vue";
import reserve from "@/components/People/reserve.vue";

const shiftCharCode = (Δ) => (c) => String.fromCharCode(c.charCodeAt(0) + Δ);
export default {
  name: "People",
  components: { basic, reserve },
  data: () => ({
    身分證字號: "",
    person: null,
  }),
  computed: {
    有預約() {
      return this.person.地點 && this.person.日期;
    },
    surveyItems() {
      return Object.entries(this.person?.問卷 || {})
        .filter(([, value]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]) => ({
          key,
          value: Array.isArray(value)
            ? value.join("、")
            : typeof value == "object"
            ? JSON.stringify(value)
            : value,
        }));
    },
    hasSurvey() {
      return this.surveyItems.length > 0;
    },
  },
  methods: {
    async load() {
      this.身分證字號 = this.身分證字號.replace(
        /[！-～]/g,
        shiftCharCode(-0xfee0)
      );
      this.身分證字號 = this.身分證字號.toUpperCase();
      let person = (
        await this.axios.get(`/dashboard/person/${this.身分證字號}`)
      ).data;
      if (person) {
        this.person = person;
      } else {
        this.people = null;
        this.$toast.error("查無此身分證字號");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-key {
  width: 36%;
  vertical-align: top;
  white-space: normal;
}

.survey-value {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
